export const language = {
  zh: {
    'All': '全部',
    'Yes': '是',
    'No': '否',
    'Confirm': '确认',
    'Edit': '编辑',
    'Save': '保存',
    'Cancel': '取消',
    'Delete': '删除',
    'Delivery Market​': '大盘结算',
    'Please confirm cancellation': '请确认是否取消',
    'Confirm delete action': '请确认是否删除',
    'Confirm deletion': '请确认是否删除',
    'Confirm submission': '请确认是否提交',
    'Delivery Center': '交割中心',
    'Allocation Suggestions': '调配建议',
    'National Pork Market Quotations​​': '全国猪肉行情',
    'War-room Data Dashboard': '战房数据看板',
    'Pork Delivery Market': '猪肉交割大盘',
    'Poultry delivery market​': '禽肉交割大盘',
    'Poultry Task List': '禽肉任务列表',
    'Date Range': '日期范围',
    'Company Name / Delivery Company': '公司名称/交割公司',
    'Delivery Success Status': '是否交割成功',
    'Please select whether the delivery is successful': '请选择是否交割成功',
    'Reset': '重置',
    'Search': '搜索',
    'Import Current Delivery Prices': '导入本期交割价格',
    'Export': '导出',
    'Current Delivery Instructions​': '本期交割意见',
    'Price Validity Period': '价格有限期',
    'Product Code': '商品编码',
    'Product Code1': '产品编码',
    'Product Name': '商品名称',
    'Product Name1': '产品名称',
    'Product Type': '商品类型',
    'Delivery Unit': '交割单位',
    'Company Name': '公司名称',
    'Company Type': '公司类型',
    'Channel': '渠道',
    'please Select Channel​': '渠道',
    'Delivery Price': '交割价',
    'Delivery Volume (kg)': '交割量(kg)',
    'Red Line Price': '红线价',
    'Delivery Company': '交割公司',
    'Buyer Remarks': '需求方备注',
    'Supplier Remarks': '供应方备注',
    'Update Time': '更新时间',
    'Operation': '操作',
    'Import Delivery Prices': '导入交割价格',
    'Download': '下载',
    'Upload': '上传',
    'Download Template': '下载模版',
    'Upload Template': '上传模版',
    'Buyer': '需求方',
    'No Data Available': '暂无数据',
    'Pork Task List': '猪肉任务列表',
    'Price Validity Range': '价格有效期范围',
    'Task ID': '任务ID',
    'Task Name': '任务名称',
    'Price Validity': '价格有效期',
    'Buyer Submission Cycle': '需求方提报周期',
    'Supplier Submission Cycle': '供应方提报周期',
    'Action': '操作',
    'Buyer Prices': '需求方价格',
    'Requirement (kg)': '需求量(kg)',
    'Indicative EXW Price': '意向自提价格',
    'Target Landed Cost​​': '意向到货价格',
    'Group External Quotation​': '集团外询价',
    'Remarks': '备注',
    'Supplier Prices': '供应方价格',
    'Supplier': '供应方',
    'Available Volume (kg)': '可供量(kg)',
    'Self-collection Price': '可供自提价格',
    'Available Delivery Price': '可供到货价格',
    'Inventory Age​​': '货龄',
    'Factory to War Zone': '工厂到战区',
    'Time': '时间',
    'Originating Factory': '调出工厂',
    'Receiving Province': '调入省区',
    'Total Allocation Volume (kg)': '调配总量(kg)',
    'Value Added (CNY)': '增值(元)',
    'Initial Volume at Originating Factory (kg)': '调出工厂初始量(kg)',
    'Remaining Volume after Transfer (kg)': '调出后剩余量(kg)',
    'Initial Volume at Receiving Province (kg)': '调入省区初始量(kg)',
    'Total Volume after Transfer (kg)': '调入后省区总量(kg)',
    'Number of Vehicles Used': '用车数',
    'Sales Forecast at Originating Factory (kg)': '调出工厂销售预测(kg)',
    'Factory Cost Price (kg/CNY)': '工厂成本价(kg/元)',
    'Sales Forecast at Receiving Province (kg)': '调入省区销售预测(kg)',
    'War Zone Selling Price (kg/CNY)': '战区销售价(kg/元)',
    'Delivery Distance (km)': '配送距离（km）',
    'Logistics Cost (CNY)': '物流费用（元）',
    'Historical Procurement Cost': '历史拿货成本',
    'Current Procurement Cost': '当前拿货成本',
    'Ex-Works Distributor Local Price (EXW DP)​': '调出销售公司当地售价',
    'Inbound Customer Sales Details​': '调入客户公司销售明细',
    'Outbound Factory Sales Forecast​': '调出工厂销量预测（kg）',
    'Inbound Provincial Sales Forecast​​': '调入省区销量预测（kg',
    'Pork Yield Rate': '猪出品率',
    'Category': '分类',
    'Trade Item​': '品项',
    'Yield Rate (%)': '出品率(%)',
    'Weight (kg)': '重量(kg)',
    'Daily Price Bulletin​': '每日牌价',
    'Product Classification​​': '产品分类',
    'Select Product Category​​': '请选择产品分类',
    'Effective Date': '生效日期',
    'Secondary Product': '产品二级',
    'Tertiary Product': '产品三级',
    'Quaternary Product': '产品四级',
    'Quinary Product': '产品五级',
    'Senary Product': '产品六级',
    'Province': '省份',
    'Company Code': '公司编码',
    'Daily Quoted Price (CNY)': '当日牌价/元',
    'External Market Price': '外部市场价格',
    'Data Source': '数据来源',
    'Date': '日期',
    'City': '市',
    'Market Name': '市场名称',
    'Average Price': '平均价',
    'Highest Price': '最高价',
    'Lowest Price': '最低价',
    'Inventory Dashboard': '库存看板',
    'Hello, no War-room access currently': '您好,暂无战房权限',
    'Bind War-room Account': '绑定战房账号',
    'If still inaccessible after adding account': '若加账号之后，还是不能访问',
    'Please verify the account and corresponding War-room permissions': '请确认账号是否正确，对应战房权限是否开通',
    'Account': '账号',
    'Password': '密码',
    'Price Dashboard': '价格看板',
    'Price validity period': '价格有效期范围',
    'View': '查看',
    'Please Enter': '请输入',
    'Please Select': '请选择',
    'Unit: CNY/kg​': '单位: 元/kg',
    'Confirm shutdown? Error files will become unavailable for download after shutdown': '请确认是否关闭，关闭之后无法下载错误文件',
    'Upload Status​': '上传状态',
    'Success / Failure​​​': '成功 / 失败',
    'Submission successful. Please navigate to the Delivery Composite for details': '提交成功,请进入交割大盘查看',
    'Please enter at least one delivery record': '请至少填写一条交割数据',
    'Please select at least one delivery data': '请至少选择一条交割数据',
    'Submit': '提交',
    'Standardized Product Name': '商品规范名称',
    'Trading Unit​​': '交易单位',
    'Expand': '展开',
    'Collapse': '收起',
    'National Pork Food Inventory​': '全国猪肉食品库存',
    'National inventory': '全国库存',
    'Please confirm if you want to unbind': '请确认是否解绑',
    'National Projection of Pork Product Prices and Allocation Profit Increase by Region': '全国猪食品价格及调配利润提升预估-分地区',
    'National Breakdown by Region': '全国分地区',
    'Forecast of Pork Product Price and Profit Increases from Allocation by Province - By Region': '各省猪食品价格及调配利润提升预估-分地区',
    '​​Administrative sub-regions by province​': '各省分地区',
    'Projected Rise in National Hog Product Prices and Allocation Margins By Channel': '全国猪食品价格及调配利润提升预估-分渠道',
    'National Distribution Channels': '全国分渠道',
    'Pork Price Display Board': '猪肉牌价展示看板',
    'Price Display': '牌价展',
  },
  en: {
    'All': 'All',
    'Yes': 'Yes',
    'No': 'No',
    'Confirm': 'Confirm',
    'Edit': 'Edit',
    'Save': 'Save',
    'Cancel': 'Cancel',
    'Delete': 'Delete',
    'Delivery Market​': 'Delivery Market​',
    'Please confirm cancellation': 'Please confirm cancellation',
    'Confirm delete action': 'Confirm delete action',
    'Confirm deletion': 'Confirm deletion',
    'Confirm submission': 'Confirm submission',
    'Delivery Center': 'Delivery Center',
    'Allocation Suggestions': 'Allocation Suggestions',
    'National Pork Market Quotations​​': 'National Pork Market Quotations​​',
    'War-room Data Dashboard': 'War-room Data Dashboard',
    'Pork Delivery Market': 'Pork Delivery Market',
    'Poultry delivery market​': 'Poultry delivery market​',
    'Poultry Task List': 'Poultry Task List',
    'Date Range': 'Date Range',
    'Company Name / Delivery Company': 'Company Name / Delivery Company',
    'Delivery Success Status': 'Delivery Success Status',
    'Please select whether the delivery is successful': 'Please select whether the delivery is successful',
    'Reset': 'Reset',
    'Search': 'Search',
    'Import Current Delivery Prices': 'Import Current Delivery Prices',
    'Export': 'Export',
    'Current Delivery Instructions​': 'Current Delivery Instructions​',
    'Price Validity Period': 'Price Validity Period',
    'Product Code': 'Product Code',
    'Product Code1': 'Product Code',
    'Product Name': 'Product Name',
    'Product Name1': 'Product Name',
    'Product Type': 'Product Type',
    'Delivery Unit': 'Delivery Unit',
    'Company Name': 'Company Name',
    'Company Type': 'Company Type',
    'Channel': 'Channel',
    'please Select Channel​': 'please Select Channel​',
    'Delivery Price': 'Delivery Price',
    'Delivery Volume (kg)': 'Delivery Volume (kg)',
    'Red Line Price': 'Red Line Price',
    'Delivery Company': 'Delivery Company',
    'Buyer Remarks': 'Buyer Remarks',
    'Supplier Remarks': 'Supplier Remarks',
    'Update Time': 'Update Time',
    'Operation': 'Operation',
    'Import Delivery Prices': 'Import Delivery Prices',
    'Download': 'Download',
    'Upload': 'Upload',
    'Download Template': 'Download Template',
    'Upload Template': 'Upload Template',
    'Buyer': 'Buyer',
    'No Data Available': 'No Data Available',
    'Pork Task List': 'Pork Task List',
    'Price Validity Range': 'Price Validity Range',
    'Task ID': 'Task ID',
    'Task Name': 'Task Name',
    'Price Validity': 'Price Validity',
    'Buyer Submission Cycle': 'Buyer Submission Cycle',
    'Supplier Submission Cycle': 'Supplier Submission Cycle',
    'Buyer Prices': 'Buyer Prices',
    'Requirement (kg)': 'Requirement (kg)',
    'Indicative EXW Price': 'Indicative EXW Price',
    'Target Landed Cost​​': 'Target Landed Cost​​',
    'Group External Quotation​': 'Group External Quotation​',
    'Remarks': 'Remarks',
    'Supplier Prices': 'Supplier Prices',
    'Supplier': 'Supplier',
    'Available Volume (kg)': 'Available Volume (kg)',
    'Self-collection Price': 'Self-collection Price',
    'Available Delivery Price': 'Available Delivery Price',
    'Inventory Age​​': 'Inventory Age​​',
    'Factory to War Zone': 'Factory to War Zone',
    'Time': 'Time',
    'Originating Factory': 'Originating Factory',
    'Receiving Province': 'Receiving Province',
    'Total Allocation Volume (kg)': 'Total Allocation Volume (kg)',
    'Value Added (CNY)': 'Value Added (CNY)',
    'Initial Volume at Originating Factory (kg)': 'Initial Volume at Originating Factory (kg)',
    'Remaining Volume after Transfer (kg)': 'Remaining Volume after Transfer (kg)',
    'Initial Volume at Receiving Province (kg)': 'Initial Volume at Receiving Province (kg)',
    'Total Volume after Transfer (kg)': 'Total Volume after Transfer (kg)',
    'Number of Vehicles Used': 'Number of Vehicles Used',
    'Sales Forecast at Originating Factory (kg)': 'Sales Forecast at Originating Factory (kg)',
    'Factory Cost Price (kg/CNY)': 'Factory Cost Price (kg/CNY)',
    'Sales Forecast at Receiving Province (kg)': 'Sales Forecast at Receiving Province (kg)',
    'War Zone Selling Price (kg/CNY)': 'War Zone Selling Price (kg/CNY)',
    'Delivery Distance (km)': 'Delivery Distance (km)',
    'Logistics Cost (CNY)': 'Logistics Cost (CNY)',
    'Historical Procurement Cost': 'Historical Procurement Cost',
    'Current Procurement Cost': 'Current Procurement Cost',
    'Ex-Works Distributor Local Price (EXW DP)​': 'Ex-Works Distributor Local Price (EXW DP)​',
    'Inbound Customer Sales Details​': 'Inbound Customer Sales Details​',
    'Outbound Factory Sales Forecast​': 'Outbound Factory Sales Forecast​',
    'Inbound Provincial Sales Forecast​​': 'Inbound Provincial Sales Forecast​​',
    'Pork Yield Rate': 'Pork Yield Rate',
    'Category': 'Category',
    'Trade Item​': 'Trade Item​',
    'Yield Rate (%)': 'Yield Rate (%)',
    'Weight (kg)': 'Weight (kg)',
    'Daily Price Bulletin​': 'Daily Price Bulletin​',
    'Product Classification​​': 'Product Classification​​',
    'Select Product Category​': 'Select Product Category​',
    'Effective Date': 'Effective Date',
    'Secondary Product': 'Secondary Product',
    'Tertiary Product': 'Tertiary Product',
    'Quaternary Product': 'Quaternary Product',
    'Quinary Product': 'Quinary Product',
    'Senary Product': 'Senary Product',
    'Province': 'Province',
    'Company Code': 'Company Code',
    'Daily Quoted Price (CNY)': 'Daily Quoted Price (CNY)',
    'External Market Price': 'External Market Price',
    'Data Source': 'Data Source',
    'Date': 'Date',
    'City': 'City',
    'Market Name': 'Market Name',
    'Average Price': 'Average Price',
    'Highest Price': 'Highest Price',
    'Lowest Price': 'Lowest Price',
    'Inventory Dashboard': 'Inventory Dashboard',
    'Hello, no War-room access currently': 'Hello, no War-room access currently',
    'Bind War-room Account': 'Bind War-room Account',
    'If still inaccessible after adding account': 'If still inaccessible after adding account',
    'Please verify the account and corresponding War-room permissions': 'Please verify the account and corresponding War-room permissions',
    'Account': 'Account',
    'Password': 'Password',
    'Price Dashboard': 'Price Dashboard',
    'Price validity period': 'Price validity period',
    'View': 'View',
    'Please Enter': 'Please Enter',
    'Please Select': 'Please Select',
    'Unit: CNY/kg​': 'Unit: CNY/kg​',
    'Confirm shutdown? Error files will become unavailable for download after shutdown': 'Confirm shutdown? Error files will become unavailable for download after shutdown',
    'Upload Status​': 'Upload Status​',
    'Success / Failure​​': 'Success / Failure​​',
    'Submission successful. Please navigate to the Delivery Composite for details': 'Submission successful. Please navigate to the Delivery Composite for details',
    'Please enter at least one delivery record': 'Please enter at least one delivery record',
    'Please select at least one delivery data': 'Please select at least one delivery data',
    'Submit': 'Submit',
    'Standardized Product Name': 'Standardized Product Name',
    'Trading Unit​​': 'Trading Unit​​',
    'Expand': 'Expand',
    'Collapse': 'Collapse',
    'National Pork Food Inventory​': 'National Pork Food Inventory​',
    'National inventory': 'National inventory',
    'Please confirm if you want to unbind': 'Please confirm if you want to unbind',
    'National Projection of Pork Product Prices and Allocation Profit Increase by Region': 'National Projection of Pork Product Prices and Allocation Profit Increase by Region',
    'National Breakdown by Region': 'National Breakdown by Region',
    'Forecast of Pork Product Price and Profit Increases from Allocation by Province - By Region': 'Forecast of Pork Product Price and Profit Increases from Allocation by Province - By Region',
    '​​Administrative sub-regions by province​': '​​Administrative sub-regions by province​',
    'Projected Rise in National Hog Product Prices and Allocation Margins By Channel': 'Projected Rise in National Hog Product Prices and Allocation Margins By Channel',
    'National Distribution Channels': 'National Distribution Channels',
    'Pork Price Display Board': 'Pork Price Display Board',
    'Price Display': 'Price Display',
  }
};